import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { useAuth } from '../../contexts/AuthContext';

const MobileMenu = ({ isOpen, onClose, isAuthenticated, user }) => {
  const { logout } = useAuth();

  const handleLogout = async () => {
    await logout();
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 bg-white md:hidden">
      <div className="flex flex-col h-full">
        <div className="flex justify-between items-center p-4 border-b">
          <Link to="/" className="text-2xl font-bold text-primary" onClick={onClose}>
            Teem Wildlife Wonders
          </Link>
          <button
            onClick={onClose}
            className="text-gray-500 focus:outline-none"
          >
            <XMarkIcon className="h-6 w-6" />
          </button>
        </div>

        <nav className="flex-grow p-4">
          <ul className="space-y-4">
            <li>
              <NavLink
                to="/"
                className={({ isActive }) =>
                  `block text-lg py-2 ${
                    isActive ? 'text-primary font-medium' : 'text-gray-700'
                  }`
                }
                onClick={onClose}
              >
                Home
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/tours"
                className={({ isActive }) =>
                  `block text-lg py-2 ${
                    isActive ? 'text-primary font-medium' : 'text-gray-700'
                  }`
                }
                onClick={onClose}
              >
                Tours
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/blog"
                className={({ isActive }) =>
                  `block text-lg py-2 ${
                    isActive ? 'text-primary font-medium' : 'text-gray-700'
                  }`
                }
                onClick={onClose}
              >
                Blog
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/about"
                className={({ isActive }) =>
                  `block text-lg py-2 ${
                    isActive ? 'text-primary font-medium' : 'text-gray-700'
                  }`
                }
                onClick={onClose}
              >
                About Us
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/contact"
                className={({ isActive }) =>
                  `block text-lg py-2 ${
                    isActive ? 'text-primary font-medium' : 'text-gray-700'
                  }`
                }
                onClick={onClose}
              >
                Contact
              </NavLink>
            </li>
          </ul>

          <div className="mt-8 pt-6 border-t border-gray-200">
            {isAuthenticated ? (
              <div className="space-y-4">
                <p className="text-gray-500">Welcome, {user?.name}</p>
                
                {user?.role === 'admin' && (
                  <Link
                    to="/admin"
                    className="block py-2 text-gray-700 hover:text-primary"
                    onClick={onClose}
                  >
                    Admin Dashboard
                  </Link>
                )}
                
                <Link
                  to="/dashboard"
                  className="block py-2 text-gray-700 hover:text-primary"
                  onClick={onClose}
                >
                  My Dashboard
                </Link>
                
                <Link
                  to="/dashboard/bookings"
                  className="block py-2 text-gray-700 hover:text-primary"
                  onClick={onClose}
                >
                  My Bookings
                </Link>
                
                <Link
                  to="/dashboard/profile"
                  className="block py-2 text-gray-700 hover:text-primary"
                  onClick={onClose}
                >
                  Profile Settings
                </Link>
                
                <button
                  onClick={handleLogout}
                  className="block w-full text-left py-2 text-gray-700 hover:text-primary"
                >
                  Logout
                </button>
              </div>
            ) : (
              <div className="space-y-4">
                <Link
                  to="/login"
                  className="block w-full py-2 text-center border-2 border-primary text-primary rounded-md hover:bg-primary hover:text-white transition-colors"
                  onClick={onClose}
                >
                  Login
                </Link>
                <Link
                  to="/register"
                  className="block w-full py-2 text-center bg-primary text-white rounded-md hover:bg-primary-dark transition-colors"
                  onClick={onClose}
                >
                  Register
                </Link>
              </div>
            )}
          </div>
        </nav>
      </div>
    </div>
  );
};

export default MobileMenu;
